import type { ActionModel } from '@jet/environment/types/models';
import type { CommerceRoute } from '~/utils/commerce';

export interface CommerceModalAction extends ActionModel {
    $kind: 'commerceModalAction';
    operation: CommerceModalActionOperation;
}

export enum CommerceModalActionOperationType {
    Open = 'open',
    Close = 'close',
}

export declare type CommerceModalActionOperation = {
    type: CommerceModalActionOperationType;
    activePath: CommerceRoute;
    modalParams?: { [key: string]: any };
};

export function makeCommerceModalAction(
    operation: CommerceModalActionOperation,
): CommerceModalAction {
    return {
        $kind: 'commerceModalAction',
        operation,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
}
